
    export const BuildCommit = 'd11caeeb34c5d748c59715023c7b409f88c35e2f';
    export const BuildVersion = '3.0.4';
